import { getEnumValues, TypeGuard } from '@principle-theorem/shared';
import { isBoolean, isNumber, isString } from 'lodash';

export enum PricingScope {
  PerTooth = 'perTooth',
  PerQuadrant = 'perQuadrant',
}

export enum PricingUnitType {
  PerTooth = 'perTooth',
  PerQuadrant = 'perQuadrant',
}

export enum PricingRuleType {
  Flat = 'flat',
  Variable = 'variable',
  Tiered = 'tiered',
  StairStep = 'stairStep',
}

export const PRICING_RULE_TYPES = getEnumValues(PricingRuleType);
export const PRICING_SCOPES = getEnumValues(PricingScope);
export const PRICING_UNIT_TYPES = [PricingUnitType.PerTooth];

export interface IPricingRule {
  type: PricingRuleType;
  ruleItems: IPricingRuleItem[];
  unitType?: PricingUnitType;
  scope?: PricingScope;
}

export interface IPricingRuleItem {
  uid: string;
  price?: number;
  startUnit?: number;
  endUnit?: number;
  label?: string;
  selected: boolean;
}

export interface IPricingRuleProvider {
  canProvide(rule: IPricingRule): boolean;
  determinePrice(
    rule: IPricingRule,
    unitCount: number,
    unitIndex: number
  ): number | undefined;
}

export const isPricingRuleItem = TypeGuard.interface<IPricingRuleItem>({
  uid: isString,
  price: TypeGuard.undefinedOr(isNumber),
  startUnit: TypeGuard.undefinedOr(isNumber),
  endUnit: TypeGuard.undefinedOr(isNumber),
  selected: isBoolean,
  label: TypeGuard.undefinedOr(isString),
});

export const isPricingRule = TypeGuard.interface<IPricingRule>({
  type: TypeGuard.enumValue(PricingRuleType),
  ruleItems: isPricingRuleItem,
  unitType: TypeGuard.undefinedOr(TypeGuard.enumValue(PricingUnitType)),
  scope: TypeGuard.undefinedOr(TypeGuard.enumValue(PricingScope)),
});
